import _flatMap from 'lodash/flatMap'
import ERROR_CODES from 'constants/errorCode'

// Whether the server refused the Client-Session itself, i.e. getting a new
// session and retrying can fix the request. Only two errors mean that:
//   401 + 1003  the session could not be decoded ('Invalid Client-Session')
//   403 + 4000  the session is past its 24h, reported under details.idp
// Anything else (a 502 from IDP, a 4000 from another group such as a TL Lincoln
// hotel code error, 1000 'Client-Session is required') must not trigger a new
// session request. `errObj` is the object built by customFetch's errorFactory.
export function isClientSessionRejected(errObj) {
  if (errObj?.status === 401) {
    return (errObj.codes || []).includes(ERROR_CODES.INVALID_CLIENT_SESSION)
  }
  if (errObj?.status === 403) {
    return _flatMap(errObj.errors, (error) => error?.details?.idp || []).some(
      (detail) => detail?.code === ERROR_CODES.IDP_EXPIRED
    )
  }
  return false
}
